// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__SF9bF","log":"ModalInventoryLogs_log__1fILp","date":"ModalInventoryLogs_date__2b_mU","userName":"ModalInventoryLogs_userName__2tJAd"};